import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { useStore } from 'vuex';
import { generateNewStyle, writeNewStyle } from '@/utils/theme.js';
export default {
  __name: 'App',
  setup(__props) {
    const store = useStore();
    generateNewStyle(store.getters.mainColor).then(newStyleText => {
      writeNewStyle(newStyleText);
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createBlock(_component_router_view);
    };
  }
};